import { LOCALES } from 'i18n/locales';

export const coverageAssetOwnersIntl = {
    [LOCALES.ENGLISH]: {
        'coverageAssetOwners.myCoverageArea': 'My coverage area',
        'coverageAssetOwners.help.myCoverageArea': 'The map will display your organisation\'s operational area(s) within NUAR.',
        'coverageAssetOwners.otherAssetOwners': 'Other asset owners in your area',
        'coverageAssetOwners.help.otherAssetOwners': 'A list of other asset owners that operate in your area.'
    },
    [LOCALES.WELSH]: {
        'coverageAssetOwners.myCoverageArea': 'Fy ardal gwmpasu',
        'coverageAssetOwners.help.myCoverageArea': 'Bydd y map yn dangos ardal weithredol/ardaloedd gweithredol eich sefydliad o fewn NUAR.',
        'coverageAssetOwners.otherAssetOwners': '[Other asset owners in your area]',
        'coverageAssetOwners.help.otherAssetOwners': '[A list of other asset owners that operate in your area.]'
    }
};
